import { render, staticRenderFns } from "./MallTab.vue?vue&type=template&id=4b9d986a&"
import script from "./MallTab.vue?vue&type=script&lang=ts&"
export * from "./MallTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports